import { render } from "./UserPermissions.vue?vue&type=template&id=70a1ce80&scoped=true&ts=true"
import script from "./UserPermissions.vue?vue&type=script&lang=ts"
export * from "./UserPermissions.vue?vue&type=script&lang=ts"

import "./UserPermissions.vue?vue&type=style&index=0&id=70a1ce80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1ce80"]])

export default __exports__